import React from "react";
import {AbsoluteFill, Sequence} from "remotion";
import {AnimatedTitle} from "../../components/text/AnimatedTitle";
import {GradientBackground} from "../../components/backgrounds/GradientBackground";
import {SafeArea} from "../../components/layout/SafeArea";
import {Watermark} from "../../components/overlays/Watermark";
import {loadDefaultFonts} from "../../presets/fonts";
import {BRAND} from "../../presets/brand";
import {OrganicLayer} from "../../components/overlays/OrganicLayer";
import {FilmGrain as CinemaGrain, CinemaVignette} from "../../components/overlays/FilmGrain";

export interface Slide {
  title: string;
  body?: string;
}

export interface PresentationProps {
  slides?: Slide[];
  framesPerSlide?: number;
  backgroundColors?: string[];
  accentColor?: string;
  titleColor?: string;
  bodyColor?: string;
}

export const Presentation: React.FC<PresentationProps> = ({
  slides = [{title: "Slide 1", body: "Content here"}],
  framesPerSlide = 150,
  backgroundColors = ["#0a0a0a", "#1a1a2e"],
  accentColor = "#6366f1",
  titleColor = "#ffffff",
  bodyColor = "rgba(255,255,255,0.8)",
}) => {
  loadDefaultFonts();

  return (
    <OrganicLayer intensity="subtle" seed="presentation">
    <AbsoluteFill>
      <GradientBackground colors={backgroundColors} angle={135} />

      {slides.map((slide, i) => (
        <Sequence
          key={i}
          from={i * framesPerSlide}
          durationInFrames={framesPerSlide}
        >
          <SafeArea paddingHorizontal={100} paddingVertical={100}>
            <AbsoluteFill
              style={{
                justifyContent: "center",
                alignItems: "flex-start",
                padding: "0 100px",
              }}
            >
              {/* Slide number */}
              <div
                style={{
                  fontSize: 18,
                  color: accentColor,
                  fontWeight: 600,
                  marginBottom: 16,
                  letterSpacing: 3,
                  textTransform: "uppercase",
                }}
              >
                {String(i + 1).padStart(2, "0")} / {String(slides.length).padStart(2, "0")}
              </div>

              <AnimatedTitle
                text={slide.title}
                fontSize={56}
                fontWeight={700}
                color={titleColor}
                textAlign="left"
                enterAnimation="slideUp"
                exitAnimation="fade"
                enterDuration={20}
                holdDuration={framesPerSlide - 50}
                exitDuration={15}
                maxWidth="100%"
              />

              {slide.body && (
                <div style={{marginTop: 24}}>
                  <AnimatedTitle
                    text={slide.body}
                    fontSize={28}
                    fontWeight={400}
                    color={bodyColor}
                    textAlign="left"
                    enterAnimation="fade"
                    exitAnimation="fade"
                    enterDuration={25}
                    holdDuration={framesPerSlide - 55}
                    exitDuration={15}
                    maxWidth="100%"
                  />
                </div>
              )}
            </AbsoluteFill>
          </SafeArea>

          {/* Accent line */}
          <div
            style={{
              position: "absolute",
              left: 80,
              top: 100,
              bottom: 100,
              width: 3,
              backgroundColor: accentColor,
              borderRadius: 2,
            }}
          />
        </Sequence>
      ))}

      <Watermark text={BRAND.handle} corner="bottomRight" opacity={0.4} fontSize={14} color="#ffffff" />
      <CinemaGrain opacity={0.06} />
      <CinemaVignette opacity={0.5} />
    </AbsoluteFill>
    </OrganicLayer>
  );
};

;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
